var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.939,
    y1: 0.025,
    x2: 0.016,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f27c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#df3d86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7da4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67396",
    "data-name": "Group 67396",
    transform: "translate(0 0.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22928",
    "data-name": "Rectangle 22928",
    width: 24,
    height: 24,
    rx: 7,
    transform: "translate(0 -0.245)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-instagram",
    "data-name": "Icon feather-instagram",
    transform: "translate(4.004 4.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82401",
    "data-name": "Path 82401",
    d: "M6.858,3h7.716a3.858,3.858,0,0,1,3.858,3.858v7.716a3.858,3.858,0,0,1-3.858,3.858H6.858A3.858,3.858,0,0,1,3,14.575V6.858A3.858,3.858,0,0,1,6.858,3Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82402",
    "data-name": "Path 82402",
    d: "M18.2,14.569a3.087,3.087,0,1,1-2.6-2.6A3.087,3.087,0,0,1,18.2,14.569Z",
    transform: "translate(-7.402 -7.339)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82403",
    "data-name": "Path 82403",
    d: "M26.25,9.75h0",
    transform: "translate(-14.29 -6.278)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullInsta);
export default __webpack_public_path__ + "static/media/icon-full-insta.c76c04ce9aaf21aa06eb7579fd73f743.svg";
export { ForwardRef as ReactComponent };